import React from 'react';
import { Descriptions } from 'antd';
import { useTranslation } from 'react-i18next';
import { ExpenseStatusProps } from '../types';

/**
 * ExpenseStatus Component
 *
 * Displays expense status information including:
 * - Who approved/submitted the expense
 * - Current status of the expense
 *
 * Only renders when status is not empty
 */
export const ExpenseStatus: React.FC<ExpenseStatusProps> = ({
  status,
  submitterInfo,
}) => {
  const { t } = useTranslation();

  return (
    <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
      <Descriptions column={1} size="small" bordered>
        <Descriptions.Item label={t('Approved by')}>
          {submitterInfo.firstName} {submitterInfo.lastName}
        </Descriptions.Item>
        <Descriptions.Item label={t('Status')}>
          {status ? t(status) : t('New Expense')}
        </Descriptions.Item>
      </Descriptions>
    </div>
  );
};
